// Automatically generated from TW.Saga.Core.Schema, Version=1.0.0.0, Culture=neutral, PublicKeyToken=null @15.06.2017 16:59:22
import { CTacticalSituation_abstract } from './../abstract/SagaSchema/CTacticalSituation_abstract';
export class CTacticalSituation extends CTacticalSituation_abstract {}
